export default __webpack_public_path__ + "static/media/copy.6ec2d9e6.svg";